import React from "react";
/** Components Import */
import Card from "./Card_wrap";
import BasicInput from "./Input_Basic";
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";

function Checking(
  { datas = [] },
  portalId,
  popperClassName,
  style,
  showIcon,
  selected,
  onChange,
  dateFormat,
  disabled,
  className
) {
  const ChangeDatapicker = (e) => {
    onChange(e);
  };
  return (
    <Card>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "column",
        }}
      >
        {datas.map((item, index) => {
          return (
            <BasicInput
              key={index}
              // containerStyle={{ width: "280px" }}
              id={item.id}
              name={item.name}
              value={item.value}
              onChange={(e) => item.onChange(e)}
              onClick={() => {}}
              onKeyDown={() => {}}
              type={item.type}
              containerStyle={item.containerStyle}
            />
          );
        })}
      </div>
    </Card>
  );
}

Checking.defaultProps = {};

export default Checking;
